var map = {
	"./fashion/about-1.jpg": 254,
	"./fashion/about-2.jpg": 255,
	"./fashion/about-3.jpg": 256,
	"./fashion/about-4.jpg": 257,
	"./fashion/slider.jpg": 258,
	"./fashion/slider2.jpg": 259,
	"./fashion/slider3.jpg": 260,
	"./fashionx-logo-web.png": 160,
	"./happy-logo-web.png": 161,
	"./happy/about-1.jpg": 261,
	"./happy/about-2.jpg": 262,
	"./happy/about-3.jpg": 263,
	"./happy/about-4.jpg": 264,
	"./happy/slider.jpg": 265,
	"./happy/slider2.jpg": 266,
	"./happy/slider3.jpg": 267,
	"./not-available.jpg": 159,
	"./ws.png": 162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 253;